import { defineComponent as _defineComponent } from 'vue'
import { PartnerReport, TradeState, closedTradeStates, CommissionDisplayType } from 'ah-api-gateways';
import TradeReportInfoDetails from 'ah-trades/src/components/info/TradeReportInfoDetails.vue';
import TradeReportDetails from 'ah-trades/src/components/info/TradeReportDetails.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeAndCommissionDetails',
  props: {
    commission: null,
    displayType: { default: CommissionDisplayType.ORIGINAL }
  },
  setup(__props: any) {



function tradeIsClosed(commission: PartnerReport) {
  return closedTradeStates.includes(commission.state);
}

function isTradeRejectedOrCanceled(commission: PartnerReport) {
  return [TradeState.CLOSED_REJECTED, TradeState.CLOSED_CANCELED].includes(commission.state);
}

return { __sfc: true,tradeIsClosed, isTradeRejectedOrCanceled, TradeReportInfoDetails, TradeReportDetails }
}

})